<gung-table [config]="config"></gung-table>
